import React, { Component } from 'react'
import service from '../../services/progressBar.service'
import { connector, ProgressBarStateProps } from './ProgressBar.state'

export interface ProgressBarProps {}

type ProgressBarCombinedProps = ProgressBarProps & ProgressBarStateProps

class ProgressBar extends Component<ProgressBarCombinedProps> {
  get className () {
    const base = 'bg-orange-500 h-[7px] transition-width ease-linear absolute inset-x-0 top-0 z-50'
    const duration = `duration-${service.incrementTime}`
    return `${base} ${duration}`
  }

  get style () {
    return { width: `${this.props.progress}%` }
  }

  render () {
    return (
      <div
        className={this.className}
        style={this.style} />
    )
  }
}

export default connector(ProgressBar)
